import $ from 'jquery';
import jump from 'jump.js';

/*************** Back to top button ***************/
let scroll_distance;
const back_to_top = $('#back_to_top_js');

$(document).scroll(function() {
  scroll_distance = $(window).scrollTop();

  if ( scroll_distance >= 150 ) {
    back_to_top.addClass('show');
  } else {
    back_to_top.removeClass('show');
  }
});

back_to_top.on('click', function(event){
  event.preventDefault();

  jump('#top_js');
});
